<template>
  <div></div>
</template>
<script>
import generateColors from "@/utils/color";
import objectAssign from "object-assign";
import { mapState } from "vuex";
export default {
  data() {
    return {
      // originalStylesheetCount: -1, //记录当前已引入style数量
      originalStyle: "", //获取拿到的.css的字符串
      colors: {
        //颜色选择器默认颜色值,这个值要和element-variables一样
        primary: "#6589f8"
      },
      cssUrl: ["//unpkg.com/element-ui/lib/theme-chalk/index.css", "/index.css"]
    };
  },
  computed: {
    ...mapState("theme", ["primaryColor"])
  },
  watch: {
    primaryColor(newV, oldV) {
      if (this.$route.path.includes("new-products")) {
        this.setThemeNew();
      }
    }
  },
  methods: {
    setThemeOld() {
      this.colors.primary = "#6589f8";
      this.initData();
    },
    setThemeNew() {
      if (!this.primaryColor) return;
      this.colors.primary = this.primaryColor;
      this.initData();
    },
    setColor(innerTxt) {
      let style = document.getElementById("dynamic-style");
      if (style) {
        style.innerText = innerTxt;
      } else {
        style = document.createElement("style");
        style.id = "dynamic-style";
        style.innerText = innerTxt;
        document.head.appendChild(style);
      }
    },
    writeNewStyle() {
      let cssText = this.originalStyle;
      Object.keys(this.colors).forEach(key => {
        cssText = cssText.replace(new RegExp("(:|\\s+)" + key, "g"), "$1" + this.colors[key]);
      });
      const innerTxt = ".primaryColor{background-color:" + this.colors.primary + "}" + cssText;
      this.setColor(innerTxt);
    },
    getIndexStyle(url) {
      let that = this;
      var request = new XMLHttpRequest();
      request.open("GET", url);
      request.onreadystatechange = function() {
        if (request.readyState === 4 && (request.status == 200 || request.status == 304)) {
          // 调用本地的如果拿不到会得到html,html是不行的
          if (request.response && !/DOCTYPE/gi.test(request.response)) {
            that.originalStyle = that.getStyleTemplate(request.response);
            that.writeNewStyle();
          } else {
            that.originalStyle = "";
          }
        } else {
          that.originalStyle = "";
        }
      };
      request.send(null);
    },
    getStyleTemplate(data) {
      const colorMap = {
        "#3a8ee6": "shade-1",
        "#409eff": "primary",
        "#53a8ff": "light-1",
        "#66b1ff": "light-2",
        "#79bbff": "light-3",
        "#8cc5ff": "light-4",
        "#a0cfff": "light-5",
        "#b3d8ff": "light-6",
        "#c6e2ff": "light-7",
        "#d9ecff": "light-8",
        "#ecf5ff": "light-9"
      };
      Object.keys(colorMap).forEach(key => {
        const value = colorMap[key];
        data = data.replace(new RegExp(key, "ig"), value);
      });
      return data;
    },
    initData() {
      // 默认从线上官方拉取最新css,2秒钟后做一个检查没有拉到就从本地在拉下
      let that = this;
      // 如果是记住用户的状态就需要，在主题切换的时候记录颜色值，在下次打开的时候从新赋值
      this.colors = objectAssign({}, this.colors, generateColors(this.colors.primary));
      this.getIndexStyle(this.cssUrl[0]);
      setTimeout(function() {
        if (that.originalStyle) {
          return;
        } else {
          that.getIndexStyle(that.cssUrl[1]);
        }
      }, 2000);
    }
  },
  mounted() {
    if (this.$route.path.includes("new-products")) {
      this.setThemeNew();
    }
  }
};
</script>
<style></style>
